/** Troca `{chave}` pelos valores, como o `format` do `web2`. Chave sem valor fica como estava. */
export const format = (template: string, values: Record<string, string | number>): string =>
  template.replace(/\{(\w+)\}/g, (whole, key: string) => (key in values ? String(values[key]) : whole))
